import { get } from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({ session: state.session }),
})

const store = new Vuex.Store({
  state: {
    session: null,
    tezos: null,
    wallet: null,
    connectedWalletAddress: null,
    pxlBalance: { available: 0, hold: 0, total: 0, pending_withdrawals: [] },
    config: {
      maxDeposit: 0,
      maxWithdrawal: 0,
    },
    // pxlEscrow: null,
    email: null,
    isVerified: null,
  },
  mutations: {
    initializeSession(state, payload) {
      state.session = payload
    },
    clearSession(state) {
      state.session = null
    },
    initializeTezos(state, payload) {
      state.tezos = payload
    },
    initializeWallet(state, payload) {
      state.wallet = payload
    },
    // initializePxlEscrow(state, payload) {
    //   state.pxlEscrow = payload
    // },
    initializeConnectedWalletAddress(state, payload) {
      state.connectedWalletAddress = payload
    },
    updatePxlBalance(state, payload) {
      state.pxlBalance = { ...state.pxlBalance, ...payload }
    },
    updateConfig(state, payload) {
      state.config = { ...state.config, ...payload }
    },
    updateUser(state, payload) {
      const updatedUser = Object.assign(state.session.user, payload)
      state.session.user = updatedUser
    },
    async clearWallet(state) {
      await state.wallet.client.clearActiveAccount()
      state.wallet = null
      state.connectedWalletAddress = null
    },
    updateEmail(state, payload) {
      state.email = payload
    },
  },
  getters: {
    isAuthenticated: (state) => {
      return state.session != null
    },
    user: (state) => {
      return get(state, 'session.user', null)
    },
    wallet: (state) => {
      return state.wallet
    },
    tezos: (state) => {
      return state.tezos
    },
    email: (state) => {
      return state.email
    },
    connectedWalletAddress: (state) => {
      return state.connectedWalletAddress
    },
    // pxlEscrow: (state) => {
    //   return state.pxlEscrow
    // },
    accessToken: (state) => {
      return get(state, 'session.accessToken', null)
    },
    pxlBalance: (state) => {
      return state.pxlBalance
    },
    config: (state) => {
      return state.config
    },
  },
  plugins: [vuexLocal.plugin],
})

export default store
